import { createReducer, on } from "@ngrx/store";
import { ambienteSeleccionado, ambienteSeleccionadoSuccess, ambienteSeleccionadoError,
        planAniosSeleccionado, planAniosSeleccionadoSuccess, planAniosSeleccionadoError,
    planInstitucionalSeleccionado, planInstitucionalSeleccionadoError, planInstitucionalSeleccionadoSuccess,elementoNivelPermiso, elementoNivelPermisoSuccess, elementoNivelPermisoError} from "./global.actions";
import { Usuario, UsuarioRedux } from 'src/app/models/usuario.model';
import { Ambiente } from "src/app/modulos/catalogos-proces/models/ambiente";
import { PlanInstitucional } from "src/app/modulos/catalogos-admin/models/plan-institucional";
import { PlanAniosInterface } from "src/app/modulos/catalogos-admin/models/plan.anios.interface";
import { Rol } from "src/app/modulos/admin/models/rol";
import { ElementoNivelPermisoInterface } from "src/app/modulos/catalogos-admin/models/elementoNivelPermiso.interface";




export interface GlobalState{
    ambienteSeleccionado: Ambiente | null;
    rolSeleccionado: Rol | null;
    planInstitucionalSeleccionado: PlanInstitucional | null;
    planAniosSeleccionado: PlanAniosInterface | null;
    elementosNivelesPermisos: ElementoNivelPermisoInterface [] | null;
    loading:boolean;
    loaded: boolean;
    error:any;    
}

export const initialState:GlobalState = {
    ambienteSeleccionado:null,
    planInstitucionalSeleccionado:null,
    planAniosSeleccionado: null,
    rolSeleccionado:null,
    elementosNivelesPermisos:null,
    loading:false,
    loaded: false, 
    error:null
}

const __globalReducer = createReducer(
    initialState,
    on(ambienteSeleccionado, (state) => ({
        ...state, 
        error:null, 
        loading:true,
        loaded:false
    })),
    on(ambienteSeleccionadoSuccess, (state, {ambiente, rol})=>({
        ...state,
        ambienteSeleccionado: ambiente,
        rolSeleccionado:rol,
        loading:false,
        loaded:true,    
        error:null
    })),
    on(ambienteSeleccionadoError, (state, {payload})=>({
        ...state,
        loading:false,
        loaded:false,
        ambienteSeleccionado: null,     
        error:{
            url:payload.url,
            status:payload.status,
            statusText:payload.statusText,                        
        }
    })),
 
    on(planInstitucionalSeleccionado, (state) => ({
        ...state, 
        error:null, 
        loading:true,
        loaded:false
    })),
    on(planInstitucionalSeleccionadoSuccess, (state, {plan})=>({
        ...state,
        planInstitucionalSeleccionado: plan,
        loading:false,
        loaded:true,    
        error:null
    })),
   
    on(planInstitucionalSeleccionadoError, (state, {payload})=>({
        ...state,
        loading:false,
        loaded:false,
        planInstitucionalSeleccionado: null,     
        error:{
            url:payload.url,
            status:payload.status,
            statusText:payload.statusText,                        
        }
    })),

    on(planAniosSeleccionado, (state) => ({
        ...state, 
        error:null, 
        loading:true,
        loaded:false
    })),
    on(planAniosSeleccionadoSuccess, (state, {plan})=>({
        ...state,
        planAniosSeleccionado: plan,
        loading:false,
        loaded:true,    
        error:null
    })),
   
    on(planAniosSeleccionadoError, (state, {payload})=>({
        ...state,
        loading:false,
        loaded:false,
        planAniosSeleccionado: null,     
        error:{
            url:payload.url,
            status:payload.status,
            statusText:payload.statusText,                        
        }
    })),


    on(elementoNivelPermiso, (state) => ({
        ...state, 
        elementosNivelesPermisos:null,
        error:null, 
        loading:true,
        loaded:false
    })),

    on(elementoNivelPermisoSuccess, (state, {elementNivelPermis})=>({
        ...state,
        elementosNivelesPermisos: elementNivelPermis,
        loading:false,
        loaded:true,    
        error:null
    })),
   
    on(elementoNivelPermisoError, (state, {payload})=>({
        ...state,
        loading:false,
        loaded:false,
        elementosNivelesPermisos: null,     
        error:{
            url:payload.url,
            status:payload.status,
            statusText:payload.statusText,                        
        }
    })),
    
);


export function globalReducer(state, action){
    return __globalReducer(state, action);
}